import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  container: css`
    .swiper-pagination-bullet {
      opacity: 1;
      height: 12px;
      width: 12px;
      background-color: #939598;
    }
    .swiper-pagination-bullet-active {
      height: 16px;
      width: 16px;
      background-color: #ffd41c;
    }
    .swiper-pagination-bullets {
      position: absolute;
      top: 26px !important;
      right: 34px;
      height: 19px;
      width: fit-content !important;
      bottom: auto !important;
      left: auto !important;
      align-items: center;
      justify-content: center;
      display: flex;
    }
    .swiper-slide {
      width: auto;
      ${theme.breakpoints.down("sm")} {
        padding-bottom: 2px;
        flex: 1;
        width: 100%;
      }
    }
  `
};
